export const MAX_RECENT_SEARCHES_COUNT = 6;
export const DEFAULT_RECENT_SEARCHES_COUNT = 3;
